import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button ,Checkbox} from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import ControlledGrid from '../Helper/ControlledGrid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Capteur from './Capteur';

import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';

/**
* Class Balise
* Balise view component
**/
class Balise extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Balise";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="baliseForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du système de mesure.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idBalise" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idBalise")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="nom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("nom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="actif">
            <Col smOffset={2} sm={4}><Checkbox name="actif" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("actif")} >Est actif</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="fournisseur">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Fournisseur</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("fournisseur")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* ElementContrat OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Capteur.getClassName()} permission={PERMISSION_READ}>
              <Grid ref="capteurGrid" title="Capteur" path="capteurs" objectPath={"balises/" + this.getObjectProperty("idBalise") + "/capteurs"}
              objectClass={Capteur} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {this.state.mode !== "add" &&
            <GeometryGrid title="Géométries" path="balises_geoms" objectPath={"balises_geoms/" + this.getObjectProperty("idBalise")} objectClass={Balise} mode={this.state.mode}
              queryLayers="BaliseCreate" allowDraw={true} selectionMultiple={false} typeGeometry="point" withImportCsv={false} withImportPoint={false} />
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * refreshContactPrincipal
  * Refresh the contactPrincipal cbx after Contact Add
  **/
  refreshContactPrincipal(obj) {
    this.refs.cbxContactPrincipal.loadData();
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idBalise";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let baliseObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.contactsGrid !== undefined) baliseObj.contacts = this.refs.contactsGrid.getArrayToSave();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(baliseObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Balise sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Balise créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/balises/" + newObj.idBalise + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.contactsGrid !== undefined) this.refs.contactsGrid.saveAll();
  }



}
export default Balise;



// WEBPACK FOOTER //
// ./src/views/Entity/Balise.js